import { AbstractEntity, User } from "..";
import { getUtcNow } from "../../utils";
import CrewListMember from './CrewListMember';
export default class CrewList extends AbstractEntity {
    static prepareEdit(crewList, author) {
        const newVersion = new CrewList({ author: User.createRef(author._id) });
        newVersion.startTimestamp = crewList.startTimestamp;
        newVersion.endTimestamp = crewList.endTimestamp;
        newVersion.predecessor = CrewList.createRef(crewList._id);
        newVersion.crewMembers = crewList.crewMembers.map((crewMember) => new CrewListMember({ ...crewMember }));
        return newVersion;
    }
    createdTimestamp;
    author;
    crewMembers = [];
    startTimestamp = getUtcNow();
    endTimestamp;
    predecessor;
    signature;
    constructor(crewList = {}) {
        super();
        Object.assign(this, crewList);
        this.createdTimestamp = getUtcNow();
    }
}
//# sourceMappingURL=CrewList.js.map